import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCertMetricsBadging,
	portal: 'SP',
};

const basePath = 'Catalogs|Other Requirements|CM Badging|';

export type SPOtherRequirementBadgeLocNames =
	| 'SPOtherRequirementBadgePageTitle'
	| 'SPOtherRequirementBadgeSectionTitle';

export const spOtherRequirementBadgeLocs: LocDefs<SPOtherRequirementBadgeLocNames> = {
	SPOtherRequirementBadgePageTitle: {
		defaultValue: 'Certmetrics Badging',
		description: 'Page title for the other requirements catalog Certmetric badging page',
		displayPath: `${basePath}Page Title`,
		displayType: 'Title',
		legacyName: 'Share.CertmetricsBadging/Catalogs.OtherRequirements.CMBadge.Title.Tab',
		...sharedProperties,
	},
	SPOtherRequirementBadgeSectionTitle: {
		defaultValue: 'Certmetrics Badging',
		description: 'Section title for the other requirements catalog Certmetric badging page',
		displayPath: `${basePath}Section Title`,
		displayType: 'Title',
		legacyName: 'Share.CertmetricsBadging/Catalogs.OtherRequirements.CMBadge.Title.Section',
		...sharedProperties,
	},
};

export type SPOtherRequirementBadgeLocType = LocMap<SPOtherRequirementBadgeLocNames>;
